// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"f08ac8cf","453":"f16537cb","936":"7180b05e"}[chunkId] + ".chunk.js";
};